import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { VENDORS } from "./apiRoutes";

const mutateUpdateVendorFinancialInfo = async ({
  vendorId,
  data,
}: {
  vendorId: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(`${VENDORS}/${vendorId}/financial-details`, data);
};

const useUpdateVendorFinancialInfoMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      vendorId: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateVendorFinancialInfo,
    ...queryParams,
  });

export default useUpdateVendorFinancialInfoMutation;
